import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ModalController, IonicModule } from "@ionic/angular";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MyToastbarComponent } from "src/app/components/my-toastbar/my-toastbar.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
@Component({
    selector: "app-see-you-soon",
    templateUrl: "./see-you-soon.component.html",
    styleUrls: ["./see-you-soon.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class SeeYouSoonComponent implements OnInit {
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  constructor(
    public dialogRef: MatDialogRef<SeeYouSoonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalCtrl: ModalController,
    private snackBar: MatSnackBar,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  ngOnInit() {}
  GotoSyndicates() {
    this.modalCtrl.dismiss({ leaveFinal: true }).catch((err) => {
      return err;
    });
    setTimeout(() => {
      /* const msg = this.translatedToastMsg?.["1061"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "Syndicate has been <b>stopped</b>", "Stop", ""); */
      this.authService.getConstantsMsg("1061").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Syndicate has been <b>stopped</b>",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          }
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
    }, 2000);
    this.dialogRef.close();
  }
}
